import React, { useEffect } from 'react';
import {
  Button, Container, Loader, Stack, Text,
} from '@mantine/core';
import { FallbackRender } from '@sentry/react';

type ErrorType = 'code-splitting' | 'unknown';

export const ErrorBoundaryFallback: FallbackRender = ({ error }) => {
  let codeSplittingError = false;
  if (error?.message?.includes('Failed to fetch dynamically imported module')) {
    codeSplittingError = true;
  }
  if (error?.message?.includes('is not a valid JavaScript MIME type')) {
    codeSplittingError = true;
  }

  const errorType: ErrorType = codeSplittingError ? 'code-splitting' : 'unknown';

  useEffect(() => {
    if (errorType === 'code-splitting') {
      const timer = setTimeout(() => {
        // auto reload
        window.location.reload();
      }, 2000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [errorType]);

  return (
    <Container>
      <Stack
        mih="100vh"
        py={50}
        justify="center"
        align="center"
      >
        {errorType !== 'code-splitting' && (
          <>
            <Text mb="sm">
              Something went wrong, please reload the page.
            </Text>
            <Button onClick={() => window.location.reload()}>
              Reload
            </Button>
          </>
        )}

        {errorType === 'code-splitting' && (
          <Loader size="sm" color="gray" />
        )}
      </Stack>
    </Container>
  );
};
